import type { IRetentionOffer } from "@apis/retention/types"
import type { IWinbackOffer } from "@apis/winbacks/types"
import { OFFER_TYPES } from "@apis/offers/types"

// The funnel keeps a single selectedOffer for both offer types, while
// eligibleOfferType is derived from the account query, which refetches whenever a
// step mounts. That means eligibleOfferType can change while an offer of the other
// type is still selected, and a cast alone would let it through to the wrong
// request (see NEE-4061).
//
// offerSource records which offers query produced the offer. It is stamped in the
// `select` of each query, the one place where the provenance is known for certain,
// and it is not part of the API payload — hence these funnel-local types rather
// than a field on IWinbackOffer / IRetentionOffer.

export type TWinbackFunnelOffer = IWinbackOffer & {
  offerSource: typeof OFFER_TYPES.Winback
}
export type TRetentionFunnelOffer = IRetentionOffer & {
  offerSource: typeof OFFER_TYPES.Retention
}
export type TFunnelOffer = TWinbackFunnelOffer | TRetentionFunnelOffer

export const isWinbackOffer = (
  offer: TFunnelOffer | null,
): offer is TWinbackFunnelOffer => offer?.offerSource === OFFER_TYPES.Winback

export const isRetentionOffer = (
  offer: TFunnelOffer | null,
): offer is TRetentionFunnelOffer =>
  offer?.offerSource === OFFER_TYPES.Retention
